import { isProd } from '@anm/shared/mode';

const pauseRemoteConsumers = false;

const audioRecordingEnabled = false; // disable because EFS is disabled

// local recording in studio
const localRecordingEnabled = !isProd;

const hot_rejoin = !isProd;

const isTwoOptionsPopupEnabled = true;

// show chooser how to record: via studio or locally
const videoRecorderChooser = true;

const qrcodes = true;

// @ts-ignore
const canUseCustomDomains = plan => {
  return true;
  // return !isProd || (plan && plan.name && plan.name.toLowerCase().includes('staff'));
};

const feedsVolume = false;

const teamsEnabled = !isProd;

const isTranslations = !isProd;

export const Features = {
  qrcodes,
  teamsEnabled,
  isTranslations,
  pauseRemoteConsumers,
  audioRecordingEnabled,
  localRecordingEnabled,
  hot_rejoin,
  feedsVolume,
  isTwoOptionsPopupEnabled,
  videoRecorderChooser,
  canUseCustomDomains
};
